<template>
<div class="mx-2 my-2">
    <div
        class="md:flex md:items-center hover:bg-grey-lighter px-2 py-4  border
            cursor-pointer hover:border-dotted hover:border-pink"
        @click="updateProduct"
    >

    <div>
        <img :src="image" :alt="title">
        <div>
            <div class="text-sm pt-2 pb-8 h-32" v-html="title" v-if="price!==200"></div>
            <div class="text-sm pt-2 pb-8" v-html="title" v-else></div>
            <div class="text-pink-darkest bold">

                <span v-if="store.addon===product">
                    <i class="fa fa-circle text-pink" aria-hidden="true"></i>
                </span>
                <span v-else>
                    <i class="fa fa-circle-o text-pink" aria-hidden="true"></i>
                </span>

                ${{total}} Total
            </div>
        </div>
    </div>

    </div>
</div>
</template>
<script>
    import store from './store.js'

    export default {
        props: ['image', 'price', 'total', 'title', 'product'],
        data() { return { store: store } },
        methods: {
            updateProduct() {
                if(this.store.addon === this.product) {
                    this.store.addon = ''
                    this.store.cost = this.store.original_cost
                } else {
                    this.store.addon = this.product
                    this.store.cost = (this.total) ? this.total : this.store.original_cost + this.price
                }
            }
        }
    }
</script>
